var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInquires(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.09,
    height: 18.094,
    viewBox: "0 0 18.09 18.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inquires",
    transform: "translate(-3.01 -2.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1375",
    "data-name": "Trazado 1375",
    d: "M12.071,3.073a8.929,8.929,0,1,1-4.216,16.8l-3.5,1.05a.97.97,0,0,1-1.208-1.209l1.05-3.5a8.93,8.93,0,0,1,7.87-13.147Zm0,1.165A7.766,7.766,0,0,0,5.334,15.863l.124.217L4.369,19.706,8,18.617l.217.124a7.765,7.765,0,1,0,3.858-14.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1376",
    "data-name": "Trazado 1376",
    d: "M12.071,3.073a8.929,8.929,0,1,1-4.216,16.8l-3.5,1.05a.97.97,0,0,1-1.208-1.209l1.05-3.5a8.93,8.93,0,0,1,7.87-13.147Zm0,1.165A7.766,7.766,0,0,0,5.334,15.863l.124.217L4.369,19.706,8,18.617l.217.124a7.765,7.765,0,1,0,3.858-14.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1377",
    "data-name": "Trazado 1377",
    d: "M3.093,12a8.941,8.941,0,0,0,1.054,4.224L3.1,19.7a1.02,1.02,0,0,0,1.27,1.271h0L7.85,19.928A8.98,8.98,0,1,0,3.093,12Zm0,0h.05m-.05,0h.05m0,0A8.891,8.891,0,0,0,4.2,16.22M3.143,12,4.2,16.22m0,0-1.05,3.5a.97.97,0,0,0,1.208,1.209Zm1.176-.382h0A7.711,7.711,0,1,1,8.238,18.7h0l-.217-.124L8,18.563l-.021.006L4.443,19.632l1.063-3.537.006-.021L5.5,16.056Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInquires);
export default __webpack_public_path__ + "static/media/Inquires.9873fc2ac693a3480a937fa20b6f7fa7.svg";
export { ForwardRef as ReactComponent };